export default "__VITE_ASSET__BH5kcHcw__"